import { Component } from '@angular/core';

@Component({
  selector: 'pcs-modal-footer',
  template: '<ng-content></ng-content>'
})
export class ModalFooterComponent {
}
